import React from "react";
import {
  ASSESSMENT_STATUS,
  ASSESSMENT_STATUS_LABELS,
  ASSESSMENT_STATUS_ORDER,
} from "./assessmentStatus";
 

const isAnsweredStatus = (questionStatus) =>
  questionStatus === "answered" || questionStatus === "answered-marked";

const ProgressOverview = ({
  status = [],
  syncStatus = {},
  questions = [],
  allowMarkForReview = false
}) => {
  const counts = status.reduce(
    (result, questionStatus, index) => {
      const questionId = questions[index]?.questionId;

      if (isAnsweredStatus(questionStatus)) {
        result.answered += 1;

        if (questionId && syncStatus[questionId] === "mongo") {
          result.mongoSaved += 1;
        }

        if (questionId && syncStatus[questionId] === "local") {
          result.localSaved += 1;
        }
      }

      if (questionStatus === "not-answered") {
        result.notAnswered += 1;
      }

      if (questionStatus === "not-visited") {
        result.notVisited += 1;
      }

      if (questionStatus === "marked" || questionStatus === "answered-marked") {
        result.marked += 1;
      }

      return result;
    },
    {
      answered: 0,
      notAnswered: 0,
      notVisited: 0,
      marked: 0,
      mongoSaved: 0,
      localSaved: 0
    }
  );
 
  const statusItems = {
    [ASSESSMENT_STATUS.NOT_ANSWERED]: {
      count: counts.notAnswered,
      dotClassName: "not-answered",
    },
    [ASSESSMENT_STATUS.NOT_VISITED]: {
      count: counts.notVisited,
      dotClassName: "not-visited",
    },
    [ASSESSMENT_STATUS.MARKED_FOR_REVIEW]: {
      count: counts.marked,
      dotClassName: "marked",
    },
    [ASSESSMENT_STATUS.ANSWERED_AND_SAVED]: {
      count: counts.mongoSaved,
      color: "#2e7d32",
    },
    [ASSESSMENT_STATUS.ANSWERS_NOT_SAVED]: {
      count: counts.localSaved,
      color: "#1976d2",
    },
  };
 
  return (
    <div className="card">
      <h3 className="font22 mb-3">Progress Overview</h3>
      {/* <ul className="progress-list">
        <li>
          <span className="dot not-answered"></span>
          Not Answered ({counts.notAnswered})
        </li>

        <li>
          <span className="dot not-visited"></span>
          Not Visited ({counts.notVisited})
        </li>
        {allowMarkForReview && (
          <li>
            <span className="dot marked"></span>
            Marked for Review ({counts.marked})
          </li>
        )}

        <li>
          <span className="dot" style={{ background: "#2e7d32" }}></span>
          Answered and Saved ({counts.mongoSaved})
        </li>

        <li>
          <span className="dot" style={{ background: "#1976d2" }}></span>
          Answers Not Saved ({counts.localSaved})
        </li>
      </ul> */}
      <ul className="progress-list">
        {ASSESSMENT_STATUS_ORDER.map((statusKey) => {
          if (
            statusKey === ASSESSMENT_STATUS.MARKED_FOR_REVIEW &&
            !allowMarkForReview
          ) {
            return null;
          }
 
          const item = statusItems[statusKey];
          const dotClassName = item.dotClassName
            ? `dot ${item.dotClassName}`
            : "dot";
 
          return (
            <li key={statusKey}>
              <span
                className={dotClassName}
                style={item.color ? { background: item.color } : undefined}
              ></span>
              {ASSESSMENT_STATUS_LABELS[statusKey]} ({item.count})
            </li>
          );
        })}
      </ul>
 
    </div>
  );
};

export default ProgressOverview;
